/* tslint:disable */

/**
 * The type of Event Emitter from filters component
 */
type EventEmitterFilterTypes = 'PARAMS' | 'BODY' | 'SHOW_HIDE_COLUMN' | 'EXPORT' | 'VIEW' | 'REFRESH';
const EventEmitterFilters = (() => {
  const PARAMS: EventEmitterFilterTypes = 'PARAMS';
  const BODY: EventEmitterFilterTypes = 'BODY';
  const SHOW_HIDE_COLUMN: EventEmitterFilterTypes = 'SHOW_HIDE_COLUMN';
  const EXPORT: EventEmitterFilterTypes = 'EXPORT';
  const VIEW: EventEmitterFilterTypes = 'VIEW';
  const REFRESH: EventEmitterFilterTypes = 'REFRESH';
  function values(): EventEmitterFilterTypes[] {
    return [PARAMS, BODY, SHOW_HIDE_COLUMN, EXPORT];
  }
  return { PARAMS, BODY, SHOW_HIDE_COLUMN, EXPORT, VIEW, REFRESH, values };
})();

export { EventEmitterFilters };
